<template>
  <div class="mx-8 notes-editor" :class="{'toolbar-hidden': !toolbarVisible }">
    <SidebarTitle icon="PenToolIcon" title="notes" class="mt-8" :plus="!showEditor" @plusClicked="showToolbarAndEditor"/>
    <quill-editor v-if="showEditor"  v-model="localValue" :options="editorOption" @keyup.enter.native.stop="" @focus="showToolbarAndEditor">
    </quill-editor>
  </div>
</template>
<script>

import _ from 'lodash'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  components: {
    quillEditor
  },
  props: ['value'],
  data () {
    return {
      localValue: null,
      editorVisible: false,
      toolbarVisible: false,
      editorOption: {
         modules: {
          toolbar: [
         [{ 'color': [] }, { 'background': [] }],

          ['bold', 'italic', 'underline'],
         [{ 'header': 1 }, { 'header': 2 }],
         [{ 'list': 'ordered'}, { 'list': 'bullet' }],
         [{ 'indent': '-1'}, { 'indent': '+1' }],
       ]
        },
        placeholder: 'your note ..',
      },
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.localValue = value
      }
    },
    localValue: {
      immediate: false,
      handler (localValue) {
        this.$emit('input', localValue)
      }
    }
  },
  computed: {
    localValueEmpty () {
      return _.isEmpty(this.localValue)
    },
    showEditor () {
      return !this.localValueEmpty || this.editorVisible
    }
  },
  methods: {
    showToolbarAndEditor () {
      this.editorVisible = true
      this.toolbarVisible = true
    }
  }
}
</script>


<style lang="scss">
.notes-editor {
  .ql-toolbar.ql-snow {
    border-radius: 1rem !important;
    border: 0 !important;
    padding: 2px !important
  }

  .ql-container.ql-snow {
    border: 1px;
  }
}

.toolbar-hidden {
  .ql-toolbar.ql-snow {
    display: none;
  }
}

</style>
